import { useMutation } from "@tanstack/react-query";
import {
  CreateEmoji,
  DeleteEmoji,
  AddImages,
  UpdateEmoji,
  DragAndDropEmoji,
} from "../../../Api/emoji";

export const useMutateCreateEmoji = () =>
  useMutation({
    mutationFn: (data) => CreateEmoji(data),
  });

export const useMutateEditEmoji = () =>
  useMutation({
    mutationFn: (data) => UpdateEmoji(data),
  });

export const useMutateDeleteEmoji = () =>
  useMutation({
    mutationFn: (data) => DeleteEmoji(data),
  });

export const useMutateCreateImage = () =>
  useMutation({
    mutationFn: (data) => AddImages(data),
  });

  export const useMutateDragDropEmoji = () =>
    useMutation({
      mutationFn: (data) => DragAndDropEmoji(data),
    });